"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseConfig = void 0;
const parseConfig = (config, parent) => {
    return config.reduce((acc, curr) => {
        let currItem = {
            name: curr.name,
            path: curr.path,
            parents: []
        };
        if (parent) {
            currItem = {
                name: curr.name,
                parents: [...parent.parents, parent],
                path: `${parent.path.replace(/\/+$/, '')}/${curr.path.replace(/^\/+/, '')}`
            };
        }
        if (curr.redirect) {
            currItem.redirect = curr.redirect;
        }
        if (curr.guards) {
            currItem.guards = curr.guards;
        }
        if (curr.resourceName) {
            currItem.resourceName = curr.resourceName;
        }
        if (curr.child) {
            return acc.concat((0, exports.parseConfig)(curr.child, currItem), [currItem]);
        }
        acc.push(currItem);
        return acc;
    }, []);
};
exports.parseConfig = parseConfig;
//# sourceMappingURL=helpers.js.map